import clsx from "clsx";
import React, { DetailedHTMLProps, FC, HTMLAttributes, PropsWithChildren } from "react";

export interface TagProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  variant?: "dark" | "light";
}

export interface TagProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  variant?: "dark" | "light";
}

export const Tag: FC<PropsWithChildren<TagProps>> = ({
  variant = "dark",
  children,
  className,
  ...rest
}) => {
  return (
    <div
      className={clsx(
        "inline-block border py-1 px-3 rounded-full uppercase text-sm",
        variant === "light" && "text-white border-white border-opacity-50",
        variant === "dark" && "border-black font-bold",
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};
